import { useParams } from 'react-router-dom';
import Breadcrumb from '../../components/common/Breadcrumb/Breadcrumb';
import ButtonIconGhostMedium from '../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { Icon } from '../../components/icon/icon';
import ROUTER from '../../routers/Routers';
import './CenterSupportPage.scss';
import { useState } from 'react';
import { Col, Collapse, Divider, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import ButtonLink from '../../components/common/ButtonLink/ButtonLink';
import { CONST } from '../../constants/constant';
import ButtonIconOutlineMedium from '../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { useTranslation } from 'react-i18next';
import i18n from '../../languages/i18n';
import { POLICIES_TEXT } from '../../constants/policiesText';

const SlugCenterSupportPage = () => {
  const { t } = useTranslation();
  const { slug } = useParams();
  const navigate = useNavigate();
  const items = {
    'terms-and-conditions': {
      title: t('Term and Policies'),
      src: <TermsAndConditions />,
    },
    faqs: {
      title: t('Frequently Asked Questions'),
      src: <FAQs />,
    },
    'warranty-policy': {
      title: t('Warranty policy'),
      src: <WarrentyPolicy />,
    },
    'sales-policy': {
      title: t('Sales policy'),
      src: <SalesPolicy />,
    },
    documents: {
      title: t('User Guide'),
      src: <Documents />,
    },
    'web-app-terms-of-use': {
      title: t('Web-App Terms of Use'),
      src: <TermsOfUse />,
    },
    'privacy-policy': {
      title: t('Privacy policy'),
      src: <PrivacyPolicy />,
    },
  };
  return (
    <div className="slug-center-support-page">
      <div className="lg:flex lg:py-16 lg:px-80 md:px-20 py-12 px-16 items-center gap-16 grid grid-cols-5 bg-fills-white lg:bg-transparent">
        <ButtonIconOutlineMedium
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
        />
        <Breadcrumb
          className="lg:flex hidden"
          items={[
            {
              title: (
                <span className="text-body-medium text-black-low">
                  {t('Support center')}
                </span>
              ),
              href: ROUTER.CENTER_SUPPORT,
            },
            ...(items[slug]
              ? [
                  {
                    title: (
                      <span className="text-body-medium-emphasized text-black-high">
                        {items[slug].title}
                      </span>
                    ),
                    href: slug,
                  },
                ]
              : []),
          ]}
        />
        <div className="col-span-3 flex lg:hidden self-stretch justify-center">
          <span className="text-title-large-emphasized text-center">
            {items[slug].title}
          </span>
        </div>
      </div>
      <div className="flex p-0 justify-center items-start lg:gap-40 gap-24 self-stretch">
        {items[slug]?.src}
      </div>
    </div>
  );
};

export default SlugCenterSupportPage;

const TermsAndConditions = () => {
  const language = i18n.language === 'vi' ? 'vi' : 'en';
  const policy = POLICIES_TEXT.termsAndConditions[language];

  return (
    <>
      <div className="flex lg:p-24 md:py-32 md:px-20 flex-col items-start gap-24 self-stretch grow rounded-[8px] bg-fills-white">
        <Collapse
          expandIcon={({ isActive }) => (
            <span className="w-16 h-16 flex">
              {isActive ? <Icon.ICExpandLess /> : <Icon.ICExpandMore />}
            </span>
          )}
          expandIconPosition="end"
          onChange={() => {}}
          className="self-stretch overflow-auto grow bg-fills-white gap-24"
          defaultActiveKey={[...policy.items.map((_, index) => index)]}
          items={[
            ...policy.items.map((item, index) => ({
              key: index,
              label: (
                <span className="text-title-medium text-black-high">
                  {item.title}
                </span>
              ),
              className:
                '!pb-24 self-stretch bg-fills-white !gap-16 !bg-fills-white [&_.ant-collapse-content-box]:!p-0 [&_.ant-collapse-header]:!px-0 :',
              children: (
                <ol className="flex flex-col gap-16 items-start self-stretch m-0 !px-16 lg:ms-24 text-label-large list-decimal text-black-medium">
                  {item.content.map((contentItem, idx) => (
                    <div key={idx} className="flex flex-col gap-6 items-start">
                      <li className="text-body-medium-emphasized">
                        {contentItem.title}
                      </li>
                      {contentItem.content && (
                        <p className="text-body-medium">{contentItem.content}</p>
                      )}
                    </div>
                  ))}
                </ol>
              ),
            })),
          ]}
        />
      </div>
    </>
  );
};

const FAQs = () => {
  const [faq, setFaq] = useState('1');

  const frequentlyAQs = [
    {
      title: 'Đặt hàng & Thanh toán',
      content: [
        {
          title: 'Tôi có thể đặt hàng như thế nào?',
          content:
            'Bạn chỉ cần chọn sản phẩm, thêm vào giỏ hàng và làm theo hướng dẫn thanh toán. Chúng tôi hỗ trợ thanh toán qua thẻ tín dụng, chuyển khoản ngân hàng và ví điện tử.',
        },
        {
          title: 'Tôi có thể hủy đơn hàng sau khi đã đặt không?',
          content:
            'Có thể, miễn là đơn hàng chưa được xử lý. Vui lòng liên hệ bộ phận hỗ trợ càng sớm càng tốt.',
        },
        {
          title: 'Tôi có thể sử dụng mã giảm giá ở đâu?',
          content:
            'Bạn có thể nhập mã giảm giá tại bước thanh toán. Nếu mã hợp lệ, hệ thống sẽ tự động áp dụng ưu đãi.',
        },
      ],
    },
    {
      title: 'Giao hàng & Vận chuyển',
      content: [
        {
          title: 'Thời gian giao hàng là bao lâu?',
          content:
            'Bạn chỉ cần chọn sản phẩm, thêm vào giỏ hàng và làm theo hướng dẫn thanh toán. Chúng tôi hỗ trợ thanh toán qua thẻ tín dụng, chuyển khoản ngân hàng và ví điện tử.',
        },
        {
          title: 'Tôi có thể theo dõi đơn hàng của mình không?',
          content:
            'Có. Sau khi đơn hàng được xác nhận, bạn sẽ nhận được email/SMS kèm mã vận đơn để theo dõi.',
        },
        {
          title: 'Phí vận chuyển được tính như thế nào?',
          content:
            'Phí vận chuyển được tính dựa trên địa điểm giao hàng và trọng lượng sản phẩm. Miễn phí vận chuyển cho đơn hàng từ 5,000,000đ trở lên.',
        },
      ],
    },
    {
      title: 'Đổi trả & Bảo hành',
      content: [
        {
          title: 'Tôi có thể đổi trả sản phẩm không?',
          content:
            'Có, trong vòng 7 ngày kể từ ngày nhận hàng nếu sản phẩm bị lỗi hoặc không đúng mô tả. Vui lòng giữ nguyên bao bì và hóa đơn.',
        },
        {
          title: 'Sản phẩm có được bảo hành không?',
          content:
            'Tùy vào loại sản phẩm. Thông tin bảo hành được ghi rõ trong phần mô tả sản phẩm hoặc phiếu bảo hành đi kèm.',
        },
      ],
    },
    {
      title: 'Hỗ trợ khách hàng',
      content: [
        {
          title:
            'Tôi có thể liên hệ với bộ phận chăm sóc khách hàng bằng cách nào?',
          content: `Bạn có thể gọi hotline: ${CONST.laNhaPhone} hoặc gửi email đến: lanhainfo@gmail.com. Thời gian hỗ trợ: 8h00–17h30 từ thứ Hai đến thứ Bảy.`,
        },
        {
          title: 'Tôi có thể gửi phản hồi hoặc khiếu nại ở đâu?',
          content:
            'Chúng tôi luôn lắng nghe! Bạn có thể gửi phản hồi qua biểu mẫu liên hệ hoặc email. Mọi khiếu nại sẽ được xử lý trong vòng 48 giờ.',
        },
      ],
    },
  ];

  return (
    <>
      <div className="flex lg:p-24 md:py-32 md:px-20 flex-col items-start gap-24 self-stretch grow rounded-[8px] bg-fills-white">
        <Collapse
          expandIcon={({ isActive }) => (
            <ButtonIconOutlineMedium
              icon={isActive ? <Icon.ICExpandLess /> : <Icon.ICExpandMore />}
            />
          )}
          expandIconPosition="end"
          onChange={() => {}}
          className="self-stretch overflow-auto grow bg-fills-white gap-24"
          defaultActiveKey={[...frequentlyAQs.map((_, index) => index)]}
          items={[
            ...frequentlyAQs.map((item, index) => ({
              key: index,
              label: (
                <span className="text-title-medium text-black-high">
                  {item.title}
                </span>
              ),
              className:
                '!pb-24 self-stretch bg-fills-white !gap-16 !bg-fills-white [&_.ant-collapse-content-box]:!p-0 [&_.ant-collapse-header]:!px-0 :',
              children: (
                <ol className="flex flex-col gap-16 items-start self-stretch m-0 !px-16 lg:ms-24 text-label-large list-decimal text-black-medium">
                  {item.content.map(item => (
                    <div className="flex flex-col gap-6 items-start">
                      <li className="text-body-medium-emphasized">
                        {item.title}
                      </li>
                      <p className="text-body-medium">{item.content}</p>
                    </div>
                  ))}
                </ol>
              ),
            })),
          ]}
        />
      </div>
    </>
  );
};

const Documents = () => {
  const { t } = useTranslation();
  const frequentlyAQs =
    i18n.language === 'vi'
      ? [
          {
            title: 'Điểm đặc biệt của sản phẩm Fitta?',
            content: [
              <ul>
                <li className="text-body-medium">
                  Sản phẩm được sản xuất dưới dạng modular - ghép các khối
                  module với nhau.
                </li>
                <li className="text-body-medium">
                  Điều đặc biệt là với công nghệ của của Fitta cho phép bạn tự
                  thiết kế món đồ nội thất ưng ý, custom trên từng module, không
                  giới hạn kiểu dáng, chi tiết bên trong và ngân sách
                </li>
              </ul>,
            ],
          },
          {
            title: 'Làm thế nào để tạo tài khoản trên Fitta?',
            content: [
              <div className="text-body-medium flex items-center gap-8">
                Ở ngay tại trang chủ Fitta, nhìn về góc trên cùng có biểu tượng
                <span className="w-24 h-24 flex items-center p-4">
                  <Icon.ICAccount />
                </span>
                nhấn tạo tài khoản.
              </div>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Với hình thức đăng ký mới, bạn cần điền thông tin mà trong box
                  yêu cầu để được tạo tài khoản trên Fitta.
                </li>
                <li className="text-body-medium">
                  Hoặc, Fitta cho phép đăng nhập thẳng trực tiếp qua Facebook,
                  Gmail mà không cần đăng ký truyền thống để tạo tài khoản trên
                  Fitta
                </li>
              </ul>,
            ],
          },
          {
            title: 'Làm sao để đăng nhập tài khoản?',
            content: [
              <div className="text-body-medium flex items-center gap-8">
                Ở ngay tại trang chủ Fitta, nhìn về góc trên cùng có biểu tượng
                <span className="w-24 h-24 flex items-center p-4">
                  <Icon.ICAccount />
                </span>
                nhấn đăng nhập. Tại đây bạn có 3 hình thức đăng nhập
              </div>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">1- đăng nhập qua Facebook</li>
                <li className="text-body-medium">2- đăng nhập qua Gmail</li>
                <li className="text-body-medium">
                  3- nhập vào tên và mật khẩu mà bạn đã đăng ký tạo tài khoản
                  trước đó
                </li>
              </ul>,
            ],
          },
          {
            title: 'Làm sao để đặt hàng?',
            content: [
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Bạn đến trang thiết kế của tôi (nếu đã có thiết kế và lưu lại)
                  mở ra bản thiết kế và nhấn nút thanh toán mua hàng
                </li>
                <li className="text-body-medium">
                  Tiếp theo, bạn điền các thông tin theo từng bước hướng dẫn ở
                  trang thanh toán (họ tên, số nhà, số điện thoại...)
                </li>
                <li className="text-body-medium">
                  Bước cuối cùng, bạn chọn đặt cọc hoặc thanh toán hết để đặt
                  hàng Fitta sản xuất nhé
                </li>
              </ul>,
            ],
          },
          {
            title: 'Làm thế nào để thanh toán mua hàng?',
            content: [
              <span className="text-body-medium">
                Sau bước điền thông tin mua hàng, nhìn về phía tay phải có nút
                'thanh toán', bạn click vào và lựa chọn 2 hình thức:
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">Đặt cọc</li>
                <li className="text-body-medium">Thanh toán đầy đủ</li>
              </ul>,
            ],
          },
          {
            title: 'Làm thế nào để quản lý đơn hàng?',
            content: [
              <div className="text-body-medium flex items-center">
                Ở ngay tại trang chủ Fitta, nhìn về góc trên cùng có biểu tượng
                <span className="w-24 h-24 flex items-center p-4">
                  <Icon.ICAccount />
                </span>
                nhấn đơn hàng của tôi.
              </div>,
              <span className="text-body-medium">
                Tất cả thông tin đều sẽ được update/cập nhật và bạn có thể dễ
                dàng biết được đơn hàng của mình đã đến bước nào
              </span>,
            ],
          },
          {
            title: 'Sản phẩm tôi mua được tính giá như thế nào?',
            content: [
              <span className="text-body-medium">
                Thiết kế tại Fitta bạn sẽ được chọn module, vật liệu và thương
                hiệu cung cấp. Mỗi lượt click chọn sẽ được tính tự động được
                tính giá
              </span>,
              <span className="text-body-medium">
                Sản phẩm hoàn thiện sẽ được tính bằng tất cả các module bạn đã
                lựa chọn, KHÔNG chi phí phát sinh
              </span>,
            ],
          },
          {
            title:
              'Sản phẩm dùng thương hiệu gỗ nào? Tôi có được chọn thương hiệu gỗ không?',
            content: [
              <span className="text-body-medium">
                Các thương hiệu gỗ có mặt tại Fitta:
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">KES</li>
                <li className="text-body-medium">An Cường</li>
                <li className="text-body-medium">Là Nhà</li>
              </ul>,
            ],
          },
          {
            title: 'Làm thế nào để bắt đầu thiết kế?',
            content: [
              <span className="text-body-medium">
                Bạn có thể lựa chọn nhấn nút "Thiết kế ngay" hoặc "Trải nghiệm
                ngay" trên trang chủ hoặc các trang sản phẩm của Fitta để mở ra
                web-app và bắt đầu thiết kế Hoặc bạn có thể nhấn vào đường link
                này [link]
              </span>,
            ],
          },

          {
            title: 'Làm thế nào để lên bản vẽ thiết kế hoàn thiện?',
            content: [
              <span className="text-body-medium">
                Sau khi mở web app Fitta, làm theo hướng dẫn sau để lên bản vẽ
                hoàn thiện:
              </span>,
              <span className="text-body-medium-emphasized">
                - Bước 1: Thiết lập không gian
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium"> Nhấn vào "Tạo phòng mới."</li>
                <li className="text-body-medium">
                  Điền các thông tin cơ bản về diện tích/thông số phòng.
                </li>
                <li className="text-body-medium">
                  Chọn màu sắc sàn gỗ phù hợp.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Bước 2: Chọn mẫu khởi đầu
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Chọn các mẫu thiết kế do Fitta đề xuất (để chỉnh sửa lại) hoặc
                  chọn không gian trống để tự thiết kế từ đầu.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Bước 3: Lựa chọn Mô-đun và Phụ kiện (Menu chính)
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Chọn các loại tủ (tủ trên, tủ dưới, tủ khuyết cột...) từ danh
                  sách mô-đun.
                </li>
                <li className="text-body-medium">
                  Sử dụng công cụ xoay/đổi góc nhìn để quan sát thiết kế từ
                  nhiều phía.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Bước 4: Tùy chỉnh chi tiết bên trong
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Tắt hiển thị cửa tủ để nhìn rõ bên trong.
                </li>
                <li className="text-body-medium">
                  Kéo và thả các phụ kiện (vách ngăn, hộc tủ, thanh chắn...) vào
                  vị trí mong muốn.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Bước 5: Hiệu chỉnh nâng cao
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Kích thước: Điều chỉnh chiều dài, sâu, cao cho từng mô-đun
                  hoặc toàn bộ hệ tủ.
                </li>
                <li className="text-body-medium">
                  Xóa: Loại bỏ các chi tiết hoặc mô-đun không cần thiết.
                </li>
                <li className="text-body-medium">
                  Vật liệu & Màu sắc: Chọn loại gỗ, màu sắc cho khung, cánh và
                  tay nắm (Theo dõi ngân sách thay đổi trực tiếp tại đây).
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Bước 6: Hoàn tất và Đặt hàng
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Kiểm tra bản phối cuối cùng (hệ thống tự động thêm nẹp thẩm mỹ
                  cho tủ đụng trần/sát vách).
                </li>
                <li className="text-body-medium">
                  Lưu bản thiết kế để chỉnh sửa sau hoặc xác nhận đặt hàng ngay.
                </li>
              </ul>,
            ],
          },
          {
            title: 'Làm sao để điều chỉnh kích thước vách tường?',
            content: [
              <span className="text-body-medium">
                Ngay tại phần <b>"Thiết lập không gian"</b>, ở bảng thông tin
                bên phải sẽ thấy mục <b>"Cấu trúc"</b>. Hãy nhấn vào{' '}
                <b>"Thêm cột"</b>, sau đó dùng chuột click vào cột được thêm và
                nhấn giữ để di chuyển theo ý mình muốn hoặc nhập kích thước để
                ra vị trí chính xác của cột
              </span>,
            ],
          },
          {
            title: 'Làm sao để thêm cột?',
            content: [
              <span className="text-body-medium">
                Ngay tại phần <b>"Thiết lập không gian"</b>, ở bảng thông tin
                bên phải sẽ thấy mục <b>"Cấu trúc"</b>. Hãy nhấn vào{' '}
                <b>"Thêm cột"</b>, sau đó dùng chuột click vào cột được thêm và
                nhấn giữ để di chuyển theo ý mình muốn hoặc nhập kích thước để
                ra vị trí chính xác của cột
              </span>,
            ],
          },
          {
            title: 'Làm sao để thêm đà / dầm nhà?',
            content: [
              <span className="text-body-medium">
                Ngay tại phần <b>"Thiết lập không gian"</b>, ở bảng thông tin
                bên phải sẽ thấy mục <b>"Cấu trúc"</b>. Hãy nhấn vào{' '}
                <b>"Thêm cột"</b>, sau đó dùng chuột click vào cột được thêm và
                nhấn giữ để di chuyển theo ý mình muốn hoặc nhập kích thước để
                ra vị trí chính xác của cột
              </span>,
            ],
          },
          {
            title: 'Làm sao để chỉnh chọn màu tường?',
            content: [
              <span className="text-body-medium">
                Ngay tại phần <b>"Thiết lập không gian"</b>, ở bảng thông tin
                bên phải sẽ thấy mục <b>"Phối cảnh"</b>. Hãy nhấn vào{' '}
                <b>"Màu tường"</b>, bạn có thể điền mã màu hoặc tự lựa chọn qua
                ô vuông bên cạnh.
              </span>,
            ],
          },
          {
            title: 'Cách chọn màu sàn?',
            content: [
              <span className="text-body-medium">
                Ngay tại phần <b>"Thiết lập không gian"</b>, ở bảng thông tin
                bên phải sẽ thấy mục <b>"Phối cảnh"</b>. Hãy nhấn vào{' '}
                <b>"Màu sàn"</b> và lựa chọn kiểu màu gỗ bạn yêu thích"
              </span>,
            ],
          },
          {
            title: 'Cách Save/lưu lại bản thiết kế của tôi?',
            content: [
              <span className="text-body-medium">
                Sau khi hoàn tất thiết kế, hệ thống tự động thêm nẹp thẩm mỹ cho
                tủ đụng trần/sát vách.
              </span>,
              <span className="text-body-medium">
                Vầ lựa chọn <b>"Lưu bản thiết kế"</b> để chỉnh sửa sau hoặc xác
                nhận
                <b>"đặt hàng ngay"</b>.
              </span>,
            ],
          },
          {
            title: 'Cách lựa chọn module?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/l%E1%BB%B1a+ch%E1%BB%8Dn+module.mp4"
              ></video>,
            ],
          },
          {
            title: 'Điều chỉnh kích thước module như thế nào?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/%C4%91i%E1%BB%81u+ch%E1%BB%89nh+k%C3%ADch+th%C6%B0%E1%BB%9Bc.mp4"
              ></video>,
            ],
          },
          {
            title: 'Tôi muốn thêm phụ kiện thì thao tác như thế nào?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/Ph%E1%BB%A5+ki%E1%BB%87n.mp4"
              ></video>,
            ],
          },
          {
            title: 'Thêm cánh cửa đóng tủ thì làm sao?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/Th%C3%AAm+c%C3%A1nh+t%E1%BB%A7.mp4"
              ></video>,
            ],
          },
          {
            title: 'Cách đo kích thước không gian để đồ nội thất phù hợp?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/%C4%91i%E1%BB%81u+ch%E1%BB%89nh+k%C3%ADch+th%C6%B0%E1%BB%9Bc.mp4"
              ></video>,
            ],
          },
          {
            title: 'Điều chỉnh màu vật liệu cho sản phẩm như thế nào?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/Ch%E1%BB%8Dn+H%C3%A3ng+-+C%E1%BB%91t+-+B%E1%BB%81+m%E1%BA%B7t+v%C3%A1n.mp4"
              ></video>,
            ],
          },
        ]
      : [
          {
            title: 'What are the special features of Fitta products?',
            content: [
              <ul>
                <li className="text-body-medium">
                  Products are manufactured in a modular form - combining module
                  blocks together.
                </li>
                <li className="text-body-medium">
                  The special thing is that with Fitta's technology, it allows
                  you to design your own furniture according to your
                  preferences, customize each module, with unlimited styles,
                  internal details, and budget.
                </li>
              </ul>,
            ],
          },
          {
            title: 'How to create an account on Fitta?',
            content: [
              <div className="text-body-medium flex items-center gap-8">
                On the Fitta homepage itself, look at the top corner where there
                is an icon
                <span className="w-24 h-24 flex items-center p-4">
                  <Icon.ICAccount />
                </span>
                click to create an account.
              </div>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  With the new registration method, you need to fill in the
                  information in the required box to create an account on Fitta.
                </li>
                <li className="text-body-medium">
                  Or, Fitta allows you to log in directly via Facebook, Gmail
                  without needing traditional registration to create an account
                  on Fitta.
                </li>
              </ul>,
            ],
          },
          {
            title: 'How to log in to my account?',
            content: [
              <div className="text-body-medium flex items-center gap-8">
                On the Fitta homepage itself, look at the top corner where there
                is an icon
                <span className="w-24 h-24 flex items-center p-4">
                  <Icon.ICAccount />
                </span>
                click to log in. Here you have 3 login methods.
              </div>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">1- Log in via Facebook</li>
                <li className="text-body-medium">2- Log in via Gmail</li>
                <li className="text-body-medium">
                  3- Enter the username and password you registered when
                  creating your account earlier
                </li>
              </ul>,
            ],
          },
          {
            title: 'How to place an order?',
            content: [
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Go to my design page (if you already have a design saved),
                  open the design and click the payment/checkout button.
                </li>
                <li className="text-body-medium">
                  Next, you fill in the information step by step as instructed
                  on the payment page (full name, address, phone number...)
                </li>
                <li className="text-body-medium">
                  Finally, you choose to make a deposit or pay in full to place
                  an order for Fitta to manufacture.
                </li>
              </ul>,
            ],
          },
          {
            title: 'How to pay for an order?',
            content: [
              <span className="text-body-medium">
                After filling in the order information, look to the right side
                and click the 'payment' button and select one of 2 payment
                methods:
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">Deposit</li>
                <li className="text-body-medium">Full payment</li>
              </ul>,
            ],
          },
          {
            title: 'How to manage my orders?',
            content: [
              <div className="text-body-medium flex items-center">
                On the Fitta homepage itself, look at the top corner where there
                is an icon
                <span className="w-24 h-24 flex items-center p-4">
                  <Icon.ICAccount />
                </span>
                click my orders.
              </div>,
              <span className="text-body-medium">
                All information will be updated and you can easily know which
                stage your order has reached.
              </span>,
            ],
          },
          {
            title: 'How is my product priced?',
            content: [
              <span className="text-body-medium">
                When designing at Fitta, you will be able to choose modules,
                materials, and brands supplied. Each selection will be
                automatically calculated and priced.
              </span>,
              <span className="text-body-medium">
                The finished product will be calculated based on all the modules
                you have selected, with NO additional charges.
              </span>,
            ],
          },
          {
            title:
              'What wood brands does the product use? Can I choose the wood brand?',
            content: [
              <span className="text-body-medium">
                Wood brands available at Fitta:
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">KES</li>
                <li className="text-body-medium">An Cuong</li>
                <li className="text-body-medium">La Nha</li>
              </ul>,
            ],
          },
          {
            title: 'How to start designing?',
            content: [
              <span className="text-body-medium">
                You can choose to click the "Design Now" or "Experience Now"
                button on the Fitta homepage or product pages to open the
                web-app and start designing. Or you can click this link [link].
              </span>,
            ],
          },
          {
            title: 'How to create a complete design drawing?',
            content: [
              <span className="text-body-medium">
                After opening the Fitta web app, follow these steps to create a
                complete drawing:
              </span>,
              <span className="text-body-medium-emphasized">
                - Step 1: Set up the space
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">Click "Create new room."</li>
                <li className="text-body-medium">
                  Fill in basic information about the room area/dimensions.
                </li>
                <li className="text-body-medium">
                  Choose an appropriate wood floor color.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Step 2: Choose a starting template
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Choose design templates suggested by Fitta (to edit) or choose
                  an empty space to design from scratch.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Step 3: Select Modules and Accessories (Main Menu)
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Select cabinet types (upper cabinets, lower cabinets,
                  column-less cabinets...) from the modules list.
                </li>
                <li className="text-body-medium">
                  Use the rotation/view angle tools to observe the design from
                  multiple angles.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Step 4: Customize interior details
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Turn off cabinet door display to see the interior clearly.
                </li>
                <li className="text-body-medium">
                  Drag and drop accessories (dividers, drawers, rails...) to
                  your desired positions.
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Step 5: Advanced adjustments
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Size: Adjust the length, depth, height for each module or the
                  entire cabinet system.
                </li>
                <li className="text-body-medium">
                  Delete: Remove unnecessary details or modules.
                </li>
                <li className="text-body-medium">
                  Materials & Colors: Choose wood type, colors for frame, doors,
                  and handles (Track budget changes in real-time here).
                </li>
              </ul>,
              <span className="text-body-medium-emphasized">
                - Step 6: Finalize and Place Order
              </span>,
              <ul className="list-disc ml-24">
                <li className="text-body-medium">
                  Check the final color scheme (the system automatically adds
                  trim to cabinets touching the ceiling/walls).
                </li>
                <li className="text-body-medium">
                  Save the design for later editing or confirm order
                  immediately.
                </li>
              </ul>,
            ],
          },
          {
            title: 'How to adjust wall dimensions?',
            content: [
              <span className="text-body-medium">
                In the <b>"Set up space"</b> section, on the right information
                panel, you will see <b>"Structure"</b> section. Click on{' '}
                <b>"Add column"</b>, then use your mouse to click on the added
                column and drag it to your desired position, or enter dimensions
                to place the column at the exact position.
              </span>,
            ],
          },
          {
            title: 'How to add a column?',
            content: [
              <span className="text-body-medium">
                In the <b>"Set up space"</b> section, on the right information
                panel, you will see <b>"Structure"</b> section. Click on{' '}
                <b>"Add column"</b>, then use your mouse to click on the added
                column and drag it to your desired position, or enter dimensions
                to place the column at the exact position.
              </span>,
            ],
          },
          {
            title: 'How to add a beam/joist?',
            content: [
              <span className="text-body-medium">
                In the <b>"Set up space"</b> section, on the right information
                panel, you will see <b>"Structure"</b> section. Click on{' '}
                <b>"Add column"</b>, then use your mouse to click on the added
                column and drag it to your desired position, or enter dimensions
                to place the column at the exact position.
              </span>,
            ],
          },
          {
            title: 'How to adjust wall color?',
            content: [
              <span className="text-body-medium">
                In the <b>"Set up space"</b> section, on the right information
                panel, you will see <b>"Perspective"</b> section. Click on{' '}
                <b>"Wall color"</b>, you can enter a color code or choose from
                the color square next to it.
              </span>,
            ],
          },
          {
            title: 'How to choose floor color?',
            content: [
              <span className="text-body-medium">
                In the <b>"Set up space"</b> section, on the right information
                panel, you will see <b>"Perspective"</b> section. Click on{' '}
                <b>"Floor color"</b>
                and select the wood color style you prefer.
              </span>,
            ],
          },
          {
            title: 'How to save/preserve my design?',
            content: [
              <span className="text-body-medium">
                After completing the design, the system automatically adds trim
                to cabinets touching the ceiling/walls.
              </span>,
              <span className="text-body-medium">
                And select <b>"Save design"</b> to edit later or confirm
                <b>"order now"</b>.
              </span>,
            ],
          },
          {
            title: 'How to select modules?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/l%E1%BB%B1a+ch%E1%BB%8Dn+module.mp4"
              ></video>,
            ],
          },
          {
            title: 'How to adjust module dimensions?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/%C4%91i%E1%BB%81u+ch%E1%BB%89nh+k%C3%ADch+th%C6%B0%E1%BB%9Bc.mp4"
              ></video>,
            ],
          },
          {
            title: 'How to add accessories?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/Ph%E1%BB%A5+ki%E1%BB%87n.mp4"
              ></video>,
            ],
          },
          {
            title: 'How to add cabinet doors?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/Th%C3%AAm+c%C3%A1nh+t%E1%BB%A7.mp4"
              ></video>,
            ],
          },
          {
            title:
              'How to measure space dimensions for furniture to fit properly?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/%C4%91i%E1%BB%81u+ch%E1%BB%89nh+k%C3%ADch+th%C6%B0%E1%BB%9Bc.mp4"
              ></video>,
            ],
          },
          {
            title: 'How to adjust material color for the product?',
            content: [
              <video
                className="max-w-[800px] max-h-[450px] rounded-[8px]"
                autoPlay={false}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/Ch%E1%BB%8Dn+H%C3%A3ng+-+C%E1%BB%91t+-+B%E1%BB%81+m%E1%BA%B7t+v%C3%A1n.mp4"
              ></video>,
            ],
          },
        ];
  return (
    <div className="flex flex-col items-center justify-center gap-16 grow self-stretch">
      <div className="flex lg:px-80 lg:py-32 flex-col items-start gap-24 self-stretch py-16 md:px-20 px-20 lg:p-0">
        <span className="lg:text-headline-medium text-headline-small-emphasized">
          {t('User Guide')}
        </span>
        <div className="grow grid lg:grid-cols-2 lg:grid-rows-1 grid-rows-2 self-stretch lg:gap-40 gap-16">
          <div className="flex flex-col gap-24 grow self-stretch items-center justify-center rounded-[24px] lg:p-24 p-16 bg-fills-white">
            <span className="text-title-medium">{t('Tutorial Video')}</span>
            <div className="flex flex-col items-center gap-16 self-streth">
              <video
                className="md:h-[378px] h-[190px] lg:h-fit rounded-[8px]"
                autoPlay={true}
                controls={true}
                muted={true}
                src="https://lanha-storage-prod.s3.ap-southeast-1.amazonaws.com/fitta_site_images/C%C3%81CH+D%C3%99NG+APP.mp4"
              ></video>
              <ButtonLink
                className="text-Accents-Blue"
                title={'Xem đầy đủ'}
                icon={<Icon.ICOpenNewTab />}
              />
            </div>
          </div>
          <div className="flex flex-col gap-24 grow self-stretch items-center justify-center rounded-[24px] lg:p-24 p-16 bg-fills-white">
            <span className="text-title-medium">{t('Expert Support')}</span>
            <div className="flex flex-col self-stretch grow justify-center items-center gap-16">
              <div className="flex px-16 py-24 justify-center items-center gap-40 rounded-[8px] bg-fills-primary-varient w-full lg:w-[400px] text-black-medium">
                <div className="flex items-center gap-32">
                  <div className="flex w-32 h-32">
                    <Icon.ICPhone />
                  </div>
                </div>
                <div className="flex flex-col items-start gap-8">
                  <span className="text-body-medium">{t('24/7 Support')}</span>
                  <span className="text-body-medium text-black-high">
                    {CONST.laNhaPhone}
                  </span>
                </div>
              </div>
              <div className="flex px-16 py-24 justify-center items-center gap-40 rounded-[8px] bg-fills-primary-varient w-full lg:w-[400px] text-black-medium">
                <div className="flex items-center gap-32">
                  <div className="flex w-32 h-32">
                    <Icon.ICMail />
                  </div>
                </div>
                <div className="flex flex-col items-start gap-8">
                  <span className="text-body-medium">Email</span>
                  <span className="text-body-medium text-black-high">
                    {CONST.laNhaEmail}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex lg:px-80 flex-col items-start justify-center gap-24 self-stretch px-16 md:px-20 py-32 bg-fills-white">
        <span className="lg:text-headline-medium text-headline-small-emphasized">
          {t('App FAQs')}
        </span>
        <div className="flex flex-col justify-center items-start gap-24 self-stretch rounded-[8px] bg-fills-white grow lg:pt-40">
          <Collapse
            expandIcon={({ isActive }) => (
              <ButtonIconOutlineMedium
                icon={isActive ? <Icon.ICExpandLess /> : <Icon.ICExpandMore />}
              />
            )}
            expandIconPosition="end"
            onChange={() => {}}
            className="self-stretch overflow-auto grow bg-fills-white gap-24"
            defaultActiveKey={[...frequentlyAQs.map((_, index) => index)]}
            items={[
              ...frequentlyAQs.map((item, index) => ({
                key: index,
                label: (
                  <span className="text-title-medium text-black-high">
                    {item.title}
                  </span>
                ),
                className:
                  '!pb-24 self-stretch bg-fills-white !gap-16 !bg-fills-white [&_.ant-collapse-content-box]:!p-0 [&_.ant-collapse-header]:!px-0 :',
                children: item.content,
              })),
            ]}
          />
        </div>
      </div>
    </div>
  );
};

const WarrentyPolicy = () => {
  return i18n.language === 'vi' ? (
    <div className="warrenty-policy flex lg:p-40 py-32 md:px-20 px-16 flex-col lg:items-center items-start gap-24 self-stretch rounded-[8px] bg-fills-white">
      <span className="text-headline-small">Chính sách bảo hành</span>
      <span className="text-body-medium self-stretch">
        Fitta cam kết bảo hành sản phẩm nhằm đảm bảo quyền lợi khách hàng đối
        với các lỗi phát sinh từ kết cấu, kỹ thuật và sản xuất trong điều kiện
        sử dụng bình thường, đúng công năng và đúng hướng dẫn sử dụng. Chính
        sách bảo hành này áp dụng cho tất cả sản phẩm do Fitta cung cấp.
      </span>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">1. Thời gian bảo hành</span>
        <span className="text-body-medium">
          <span>
            Tất cả sản phẩm do Fitta cung cấp được áp dụng thời gian bảo hành 05
            (năm) năm, tính từ ngày:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Khách hàng nhận hàng.</li>
            <li className="font-semibold">
              Hoặc ngày nghiệm thu bàn giao sản phẩm.
            </li>
          </ul>
          <br />
          <span>Chính sách này áp dụng cho các nhóm sản phẩm:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Nội thất gỗ có sẵn</li>
            <li className="font-semibold">Sofa có sẵn</li>
            <li className="font-semibold">
              Nội thất thiết kế theo yêu cầu thông qua Web App
            </li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">
          2. Phụ kiện và linh kiện từ nhà cung cấp
        </span>
        <span className="text-body-medium">
          <span>
            Một số sản phẩm của Fitta sử dụng phụ kiện hoặc linh kiện từ các nhà
            cung cấp bên thứ ba, bao gồm nhưng không giới hạn:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Ray trượt</li>
            <li className="font-semibold">Bản lề</li>
            <li className="font-semibold">Tay nâng</li>
            <li className="font-semibold">Khóa</li>
            <li className="font-semibold">Phụ kiện bếp</li>
            <li className="font-semibold">
              Các chi tiết kim khi và cơ cấu chuyển động
            </li>
          </ul>
          <br />
          <span>
            Đối với các phụ kiện này, thời gian và điều kiện bảo hành sẽ áp dụng
            theo chính sách bảo hành của nhà cung cấp tương ứng. Fitta sẽ hỗ trợ
            khách hàng:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Kiểm tra tình trạng sản phẩm</li>
            <li className="font-semibold">Xác định nguyên nhân lỗi</li>
            <li className="font-semibold">
              Phối hợp với nhà cung cấp để thực hiện quy trình bảo hành khi cần
              thiết.
            </li>
          </ul>
          <br />
          <span>
            Thời gian xử lý bảo hành có thể phụ thuộc vào quy trình của nhà cung
            cấp.
          </span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">3. Phạm vi bảo hành</span>
        <span className="text-body-medium">
          <span>Fitta thực hiện bảo hành đối với các lỗi phát sinh từ:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Lỗi sản xuất</li>
            <li className="font-semibold">Lỗi kỹ thuật vật liệu</li>
            <li className="font-semibold">Lỗi gia công</li>
            <li className="font-semibold">Lỗi lắp đặt</li>
          </ul>
          <br />
          <span>
            trong điều kiện sử dụng bình thường. Các trường hợp bảo hành bao gồm
            nhưng không giới hạn:
          </span>
          <br />
          <br />
          <span className="text-body-large font-semibold">a. Nội thất gỗ</span>
          <ul className="list-disc ml-24">
            <li>Cong vênh bất thường của kết cấu sản phẩm</li>
            <li>Bung hoặc hở các mối liên kết kỹ thuật</li>
            <li>Lỗi dán cạnh hoặc liên kết ảnh hưởng đến độ bền</li>
            <li>Cánh tủ hoặc hộc kéo bị xệ do lỗi kỹ thuật</li>
            <li>Lỗi kết cấu ảnh hưởng đến công năng sử dụng.</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">b. Sofa</span>
          <ul className="list-disc ml-24">
            <li>Khung sofa cong hoặc gãy do lỗi kết cấu</li>
            <li>Liên kết chịu lực bị hỏng do lỗi sản xuất</li>
            <li>Đệm bị xẹp lún bất thường do lỗi vật liệu</li>
            <li>Lỗi kỹ thuật đường may hoặc liên kết bọc.</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            c. Phụ kiện vận hành
          </span>
          <ul className="list-disc ml-24">
            <li>
              Ray trượt, bản lề hoặc tay nâng hoạt động không đúng chức năng do
              lỗi kỹ thuật
            </li>
            <li>Phụ kiện hư hỏng trong điều kiện sử dụng bình thường.</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">d. Lỗi lắp đặt</span>
          <ul className="list-disc ml-24">
            <li>
              Lắp đặt sai kỹ thuật khiến sản phẩm vận hành không đúng chức năng
            </li>
            <li>Cánh tủ lệch, xệ hoặc kẹt do lỗi lắp đặt.</li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">4. Hình thức bảo hành</span>
        <span className="text-body-medium">
          <span>
            Tùy theo tình trạng thực tế, Fitta có quyền lựa chọn phương án xử lý
            phù hợp:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Điều chỉnh kỹ thuật</li>
            <li className="font-semibold">Sửa chữa bộ phận lỗi</li>
            <li className="font-semibold">Thay thế linh kiện hoặc phụ kiện</li>
            <li className="font-semibold">
              Thay thế một phần cấu kiện sản phẩm
            </li>
          </ul>
          <br />
          <span>
            Việc đổi mới toàn bộ sản phẩm chỉ áp dụng khi lỗi nghiêm trọng và
            không thể sửa chữa hợp lý
          </span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">5. Điều kiện được bảo hành</span>
        <span className="text-body-medium">
          <span>Sản phẩm được bảo hành khi đáp ứng các điều kiện:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Còn trong thời hạn bảo hành</li>
            <li className="font-semibold">Lỗi thuộc phạm vi bảo hành</li>
            <li className="font-semibold">
              Sử dụng đúng công năng và hướng dẫn
            </li>
            <li className="font-semibold">
              Khách hàng cung cấp thông tin đơn hàng hoặc chứng từ mua hàng.
            </li>
          </ul>
          <br />
          <span>Fitta có thể yêu cầu khách hàng cung cấp:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Còn trong thời hạn bảo hành</li>
            <li className="font-semibold">Lỗi thuộc phạm vi bảo hành</li>
            <li className="font-semibold">
              Sử dụng đúng công năng và hướng dẫn
            </li>
            <li className="font-semibold">
              Khách hàng cung cấp thông tin đơn hàng hoặc chứng từ mua hàng.
            </li>
          </ul>
          <br />
          <span>Fitta có thể yêu cầu khách hàng cung cấp</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Hình ảnh hiện trạng sản phẩm</li>
            <li className="font-semibold">Video mô tả lỗi</li>
            <li className="font-semibold">Thông tin đơn hàng.</li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">
          6. Các trường hợp không thuộc phạm vi bảo hành
        </span>
        <span className="text-body-medium">
          <span>Fitta có quyền từ chối bảo hành trong các trường hợp sau:</span>
          <br />
          <br />

          <span className="text-body-large font-semibold">
            a. Hao mòn tự nhiên
          </span>
          <ul className="list-disc ml-24">
            <li>Trầy xước bề mặt trong quá trình sử dụng</li>
            <li>Bạc màu vật liệu theo thời gian</li>
            <li>Nhăn hoặc giãn vật liệu bọc sofa</li>
            <li>Lún nhẹ bề mặt đệm trong giới hạn sử dụng thông thường</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            b. Sử dụng sai cách
          </span>
          <ul className="list-disc ml-24">
            <li>Sử dụng vượt tải trọng thiết kế</li>
            <li>Va đập mạnh hoặc tác động lực bất thường</li>
            <li>Tự ý tháo lắp hoặc thay đổi kết cấu sản phẩm</li>
            <li>Sửa chữa bởi đơn vị không thuộc Fitta</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            c. Hư hỏng do môi trường
          </span>
          <ul className="list-disc ml-24">
            <li>Ngập nước hoặc tiếp xúc nước kéo dài</li>
            <li>Môi trường ẩm ướt kéo dài</li>
            <li>Rò rỉ nước từ hệ thống cấp thoát nước</li>
            <li>Tiếp xúc nhiệt độ cao hoặc ánh nắng mạnh</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            d. Mối mọt và côn trùng
          </span>
          <ul className="list-disc ml-24">
            <li>Mối mọt phá hoại vật liệu gỗ</li>
            <li>Côn trùng gây hư hỏng kết cấu</li>
            <li>Hư hỏng do môi trường ẩm mốc</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            e. Gương và kính
          </span>
          <br />
          <span>
            Fitta không áp dụng bảo hành đối với gương và kính sau khi sản phẩm
            đã được giao hàng và nghiệm thu bàn giao. Các trường hợp không bảo
            hành bao gồm:
          </span>
          <ul className="list-disc ml-24">
            <li className="font-semibold">Nứt</li>
            <li className="font-semibold">Vỡ</li>
            <li className="font-semibold">Mẻ</li>
            <li className="font-semibold">Trầy xước</li>
            <li className="font-semibold">
              Hư hỏng do va chạm hoặc tác động ngoại lực
            </li>
          </ul>
          <span>
            Gương và kính là vật liệu có tính chất dễ vỡ, vì vậy khách hàng cần
            kiểm tra kỹ tại thời điểm nhận hàng. Sau khi sản phẩm đã được bàn
            giao và xác nhận tình trạng bình thường, các hư hỏng phát sinh sẽ
            không thuộc phạm vi bảo hành.
          </span>
          <br />
          <br />

          <span className="text-body-large font-semibold">
            f. Đá tự nhiên và đá nhân tạo
          </span>
          <span>
            Đối với các hạng mục sử dụng đá tự nhiên hoặc đá nhân tạo, thời gian
            và điều kiện bảo hành sẽ áp dụng theo chính sách bảo hành của nhà
            cung cấp đá. Fitta sẽ hỗ trợ khách hàng làm việc với nhà cung cấp
            trong trường hợp phát sinh lỗi, sự khác biệt về:
          </span>
          <ul className="list-disc ml-24">
            <li className="font-semibold">Màu sắc</li>
            <li className="font-semibold">Vân đá</li>
            <li className="font-semibold">Sắc độ</li>
            <li className="font-semibold">Cấu trúc bề mặt</li>
          </ul>
          <span>
            là đặc tính tự nhiên của vật liệu và không được xem là lỗi sản xuất.
          </span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">
          7. Sản phẩm thiết kế qua Web-App
        </span>
        <span className="text-body-medium">
          <span>
            Đối với sản phẩm thiết kế thông qua Web App, Fitta chỉ bảo hành đối
            với:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Lỗi sản xuất</li>
            <li className="font-semibold">Lỗi vật liệu</li>
            <li className="font-semibold">
              Sai khác so với thiết kế đã được xác nhận.
            </li>
          </ul>
          <br />
          <span>Fitta không bảo hành đối với:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">
              Thiết kế hoặc cấu hình do khách hàng lựa chọn
            </li>
            <li className="font-semibold">
              Kích thước không phù hợp không gian thực tế
            </li>
            <li className="font-semibold">
              Sai số từ thông tin kích thước do khách hàng cung cấp
            </li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">8. Quy trình bảo hành</span>
        <span className="text-body-medium">
          <span>
            Khi phát sinh yêu cầu bảo hành, khách hàng vui lòng liên hệ Fitta.
            Quy trình xử lý:
          </span>
          <br />
          <br />
          <ul className="list-decimal ml-[16px]">
            <li className="font-semibold">
              Khách hàng gửi thông tin và hình ảnh hiện trạng
            </li>
            <li className="font-semibold">Fitta tiếp nhận và đánh giá sơ bộ</li>
            <li className="font-semibold">Kỹ thuật kiểm tra thực tế nếu cần</li>
            <li className="font-semibold">Xác định phạm vi bảo hành</li>
            <li className="font-semibold">Tiến hành sửa chữa hoặc thay thế</li>
          </ul>
          <br />
          <span>
            Thời gian phản hồi ban đầu thông thường 1 – 3 ngày làm việc.
          </span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">9. Chi phí ngoài bảo hành</span>
        <span className="text-body-medium">
          <span>
            Đối với các trường hợp không thuộc phạm vi bảo hành, Fitta có thể hỗ
            trợ sửa chữa có tính phí. Chi phí có thể bao gồm:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-[16px]">
            <li className="font-semibold">Vật tư</li>
            <li className="font-semibold">Nhân công</li>
            <li className="font-semibold">Vận chuyển</li>
            <li className="font-semibold">Tháo lắp</li>
          </ul>
          <br />
          <span>Fitta sẽ thông báo chi phí trước khi thực hiện.</span>
        </span>
      </div>
    </div>
  ) : (
    <div className="warrenty-policy flex lg:p-40 py-32 md:px-20 px-16 flex-col lg:items-center items-start gap-24 self-stretch rounded-[8px] bg-fills-white">
      <span className="text-headline-small">Warranty Policy</span>
      <span className="text-body-medium self-stretch">
        Fitta is committed to providing product warranties to protect customer
        rights against defects arising from structure, technical issues, and
        manufacturing under normal conditions of use, proper functionality, and
        adherence to usage instructions. This warranty policy applies to all
        products provided by Fitta.
      </span>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">1. Warranty Period</span>
        <span className="text-body-medium">
          <span>
            All products provided by Fitta are covered by a 5-year warranty
            period, calculated from:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">
              The date customer receives the product
            </li>
            <li className="font-semibold">
              Or the date of product delivery inspection and acceptance.
            </li>
          </ul>
          <br />
          <span>This policy applies to the following product groups:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Ready-made wooden furniture</li>
            <li className="font-semibold">Ready-made sofas</li>
            <li className="font-semibold">
              Custom-designed furniture through Web App
            </li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">
          2. Accessories and Components from Suppliers
        </span>
        <span className="text-body-medium">
          <span>
            Some Fitta products use accessories or components from third-party
            suppliers, including but not limited to:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Sliding rails</li>
            <li className="font-semibold">Hinges</li>
            <li className="font-semibold">Handles</li>
            <li className="font-semibold">Locks</li>
            <li className="font-semibold">Kitchen accessories</li>
            <li className="font-semibold">
              Metal details and mechanical components
            </li>
          </ul>
          <br />
          <span>
            For these accessories, warranty period and conditions will be
            applied according to the corresponding supplier's warranty policy.
            Fitta will support customers by:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Inspecting product condition</li>
            <li className="font-semibold">Identifying the cause of defects</li>
            <li className="font-semibold">
              Coordinating with suppliers to carry out warranty procedures when
              necessary.
            </li>
          </ul>
          <br />
          <span>
            Warranty processing time may depend on the supplier's procedures.
          </span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">3. Warranty Scope</span>
        <span className="text-body-medium">
          <span>Fitta provides warranty for defects arising from:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Manufacturing defects</li>
            <li className="font-semibold">Material technical defects</li>
            <li className="font-semibold">Workmanship defects</li>
            <li className="font-semibold">Installation defects</li>
          </ul>
          <br />
          <span>
            under normal conditions of use. Warranty cases include but are not
            limited to:
          </span>
          <br />
          <br />
          <span className="text-body-large font-semibold">
            a. Wooden Furniture
          </span>
          <ul className="list-disc ml-24">
            <li>Abnormal warping of product structure</li>
            <li>Splitting or loosening of technical joints</li>
            <li>Edge gluing or joint defects affecting durability</li>
            <li>Cabinet doors or drawers sagging due to technical defects</li>
            <li>Structural defects affecting functional use.</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">b. Sofas</span>
          <ul className="list-disc ml-24">
            <li>Sofa frame bending or breaking due to structural defects</li>
            <li>
              Load-bearing connections damaged due to manufacturing defects
            </li>
            <li>
              Cushions abnormally compressed or sagging due to material defects
            </li>
            <li>Technical defects in stitching or upholstery joints.</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            c. Operating Accessories
          </span>
          <ul className="list-disc ml-24">
            <li>
              Sliding rails, hinges, or handles not functioning properly due to
              technical defects
            </li>
            <li>Accessories damaged under normal conditions of use.</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            d. Installation Defects
          </span>
          <ul className="list-disc ml-24">
            <li>
              Improper installation causing products to not function properly
            </li>
            <li>
              Cabinet doors misaligned, sagging, or stuck due to installation
              defects.
            </li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">4. Warranty Forms</span>
        <span className="text-body-medium">
          <span>
            Depending on the actual condition, Fitta may choose an appropriate
            solution:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Technical adjustment</li>
            <li className="font-semibold">Repair of defective parts</li>
            <li className="font-semibold">
              Replacement of components or accessories
            </li>
            <li className="font-semibold">
              Replacement of partial product components
            </li>
          </ul>
          <br />
          <span>
            Full product replacement only applies when defects are serious and
            cannot be reasonably repaired
          </span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">5. Warranty Conditions</span>
        <span className="text-body-medium">
          <span>
            Products are eligible for warranty when they meet these conditions:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Still within warranty period</li>
            <li className="font-semibold">
              Defects fall within warranty scope
            </li>
            <li className="font-semibold">
              Proper use according to functionality and instructions
            </li>
            <li className="font-semibold">
              Customer provides order information or purchase receipt.
            </li>
          </ul>
          <br />
          <span>Fitta may request customers to provide:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">
              Photos of current product condition
            </li>
            <li className="font-semibold">Video describing the defect</li>
            <li className="font-semibold">Order information.</li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">
          6. Cases Not Covered by Warranty
        </span>
        <span className="text-body-medium">
          <span>Fitta may refuse warranty in the following cases:</span>
          <br />
          <br />

          <span className="text-body-large font-semibold">
            a. Natural Wear and Tear
          </span>
          <ul className="list-disc ml-24">
            <li>Surface scratches from normal use</li>
            <li>Color fading of materials over time</li>
            <li>Wrinkling or stretching of sofa upholstery materials</li>
            <li>Minor cushion surface compression within normal use limits</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">b. Misuse</span>
          <ul className="list-disc ml-24">
            <li>Use exceeding design load capacity</li>
            <li>Strong impact or unusual force application</li>
            <li>Unauthorized disassembly or alteration of product structure</li>
            <li>Repair by parties other than Fitta</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            c. Environmental Damage
          </span>
          <ul className="list-disc ml-24">
            <li>Water submersion or prolonged water exposure</li>
            <li>Prolonged humid environment</li>
            <li>Water leakage from water supply or drainage systems</li>
            <li>Exposure to high temperature or strong sunlight</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            d. Termites and Insects
          </span>
          <ul className="list-disc ml-24">
            <li>Termite damage to wood materials</li>
            <li>Insect damage to structure</li>
            <li>Damage from mold or mildew conditions</li>
          </ul>
          <br />
          <span className="text-body-large font-semibold">
            e. Mirrors and Glass
          </span>
          <br />
          <span>
            Fitta does not provide warranty for mirrors and glass after product
            has been delivered and delivery inspection completed. Non-warranty
            cases include:
          </span>
          <ul className="list-disc ml-24">
            <li className="font-semibold">Cracks</li>
            <li className="font-semibold">Breakage</li>
            <li className="font-semibold">Chips</li>
            <li className="font-semibold">Scratches</li>
            <li className="font-semibold">
              Damage from collision or external force
            </li>
          </ul>
          <span>
            Mirrors and glass are fragile materials, so customers should inspect
            them carefully at the time of receipt. After product delivery and
            acceptance confirmation, any subsequent damage will not be covered
            by warranty.
          </span>
          <br />
          <br />

          <span className="text-body-large font-semibold">
            f. Natural and Artificial Stone
          </span>
          <span>
            For items using natural or artificial stone, warranty period and
            conditions will apply according to the stone supplier's warranty
            policy. Fitta will assist customers in working with suppliers in
            case of defects or differences in:
          </span>
          <ul className="list-disc ml-24">
            <li className="font-semibold">Color</li>
            <li className="font-semibold">Stone pattern</li>
            <li className="font-semibold">Tone</li>
            <li className="font-semibold">Surface structure</li>
          </ul>
          <span>
            are natural characteristics of the material and not considered
            manufacturing defects.
          </span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">7. Web-App Designed Products</span>
        <span className="text-body-medium">
          <span>
            For products designed through Web App, Fitta only provides warranty
            for:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">Manufacturing defects</li>
            <li className="font-semibold">Material defects</li>
            <li className="font-semibold">
              Discrepancies from the confirmed design.
            </li>
          </ul>
          <br />
          <span>Fitta does not provide warranty for:</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            <li className="font-semibold">
              Design or configuration chosen by customer
            </li>
            <li className="font-semibold">
              Sizes not fitting the actual space
            </li>
            <li className="font-semibold">
              Errors from dimension information provided by customer
            </li>
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">8. Warranty Process</span>
        <span className="text-body-medium">
          <span>
            When a warranty claim arises, customers should contact Fitta.
            Processing procedure:
          </span>
          <br />
          <br />
          <ul className="list-decimal ml-[16px]">
            <li className="font-semibold">
              Customer submits information and current product photos
            </li>
            <li className="font-semibold">
              Fitta receives and makes initial assessment
            </li>
            <li className="font-semibold">Technical inspection if necessary</li>
            <li className="font-semibold">Determine warranty scope</li>
            <li className="font-semibold">
              Proceed with repair or replacement
            </li>
          </ul>
          <br />
          <span>Initial response time is typically 1-3 business days.</span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">9. Costs Outside Warranty</span>
        <span className="text-body-medium">
          <span>
            For cases outside warranty scope, Fitta may provide paid repairs.
            Costs may include:
          </span>
          <br />
          <br />
          <ul className="list-disc ml-[16px]">
            <li className="font-semibold">Materials</li>
            <li className="font-semibold">Labor</li>
            <li className="font-semibold">Transportation</li>
            <li className="font-semibold">Disassembly and assembly</li>
          </ul>
          <br />
          <span>Fitta will inform customers of costs before proceeding.</span>
        </span>
      </div>
    </div>
  );
};

const vietnameseSalesPolicySections = [
  {
    title: '1. Phạm vi áp dụng',
    content: (
      <span className="text-body-medium">
        <span>
          Chính sách này áp dụng cho tất cả khách hàng mua sản phẩm thông qua
          các kênh sau:
        </span>
        <br />
        <br />
        <ul className="list-disc ml-24">
          <li className="font-semibold">Website chính thức của Fitta</li>
          <li className="font-semibold">Showroom Fitta</li>
          <li className="font-semibold">
            Các kênh bán hàng trực tuyến của Fitta (Facebook, Zalo hoặc các nền
            tảng khác)
          </li>
        </ul>
      </span>
    ),
  },
  {
    title: '2. Phân loại sản phẩm',
    content: (
      <span className="text-body-medium">
        <span>Các sản phẩm tại Fitta được chia thành 3 nhóm chính</span>
        <br />
        <br />
        <span className="text-body-large font-semibold">
          a. Nội thất gỗ có sẵn
        </span>
        <br />
        <span>
          Là các sản phẩm được thiết kế và sản xuất sẵn theo module tiêu chuẩn.
          Ví dụ:
        </span>
        <ul className="list-disc ml-24">
          <li>Tủ</li>
          <li>Bàn</li>
          <li>Kệ</li>
          <li>Giường</li>
          <li>Tủ bếp module</li>
        </ul>
        <span>Đặc điểm</span>
        <ul className="list-disc ml-24">
          <li>Sản phẩm có sẵn hoặc sản xuất nhanh</li>
          <li>Kích thước và cấu hình theo tiêu chuẩn của Fitta</li>
          <li>Không thay đổi kích thước theo yêu cầu riêng.</li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">b. Sofa có sẵn</span>
        <br />
        <span>Các mẫu sofa được thiết kế sẵn với các lựa chọn về:</span>
        <ul className="list-disc ml-24">
          <li>Màu sắc</li>
          <li>Chất liệu</li>
          <li>Kích thước tiêu chuẩn</li>
        </ul>
        <span>
          Trong một số trường hợp, khách hàng có thể thay đổi màu vải hoặc da
          theo bảng vật liệu của Fitta.
        </span>
        <br />
        <br />
        <span className="text-body-large font-semibold">
          c. Nội thất thiết kế qua Web-App
        </span>
        <br />
        <span>Khách hàng có thể:</span>
        <ul className="list-disc ml-24">
          <li>Tự thiết kế nội thất trực tiếp trên Web App</li>
          <li>Tùy chỉnh kích thước</li>
          <li>Tùy chỉnh module</li>
          <li>Tùy chỉnh vật liệu.</li>
        </ul>
        <span>
          Sau khi khách hàng xác nhận thiết kế và đơn hàng, Fitta sẽ tiến hành
          sản xuất theo thiết kế đã được chốt. Đây là sản phẩm sản xuất theo yêu
          cầu riêng (custom-made).
        </span>
      </span>
    ),
  },
  {
    title: '3. Quy trình đặt hàng',
    content: (
      <span className="text-body-medium">
        <span className="text-body-large font-semibold">
          a. Đối với nội thất gỗ và sofa có sẵn
        </span>
        <br />
        <span>Quy trình đặt hàng:</span>
        <ul className="list-disc ml-24">
          <li>Khách hàng lựa chọn sản phẩm trên website hoặc tại showroom</li>
          <li>Fitta xác nhận đơn hàng</li>
          <li>Khách hàng thực hiện thanh toán</li>
          <li>Giường</li>
          <li>Fitta tiến hành giao hàng.</li>
        </ul>
        <br />
        <span>Thời gian giao hàng</span>
        <br />
        <ul className="list-disc ml-24">
          <li>
            Khu vực nội thành TP.HCM (theo địa giới TP.HCM trước khi sáp nhập):
            1 – 3 ngày làm việc.
          </li>
          <li>
            Khu vực ngoại tỉnh (ngoài TP.HCM theo địa giới cũ): 3 – 7 ngày làm
            việc tùy khu vực vận chuyển.
          </li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">
          b. Đối với sản phẩm thiết kế qua Web App
        </span>
        <span>Quy trình đặt hàng:</span>
        <ul className="list-disc ml-24">
          <li>Khách hàng thiết kế sản phẩm trên Web App</li>
          <li>Fitta xác nhận thiết kế và báo giá</li>
          <li>Khách hàng đặt cọc đơn hàng</li>
          <li>Fitta tiến hành sản xuất</li>
          <li>Giao hàng và lắp đặt.</li>
        </ul>
        <br />
        <br />
        <span>
          Thời gian sản xuất phụ thuộc vào vật liệu khách hàng lựa chọn:
        </span>
        <ul className="list-disc ml-24">
          <li>
            <strong>5 – 7 ngày làm việc:</strong> áp dụng khi khách hàng chọn
            các mẫu ván có sẵn trong danh mục vật liệu tiêu chuẩn của Fitta.
          </li>
          <li>
            <strong>14 – 24 ngày làm việc:</strong> áp dụng khi khách hàng chọn
            các mẫu ván ngoài danh mục tiêu chuẩn hoặc cần đặt vật liệu riêng.
          </li>
        </ul>
        <span>
          Thời gian có thể thay đổi tùy theo quy mô đơn hàng và điều kiện sản
          xuất.
        </span>
      </span>
    ),
  },
  {
    title: '4. Chính sách thanh toán',
    content: (
      <span className="text-body-medium">
        <span>Fitta chấp nhận các phương thức thanh toán:</span>
        <br />
        <br />
        <ul className="list-disc ml-24">
          <li className="font-semibold">Chuyển khoản ngân hàng</li>
          <li className="font-semibold">Thanh toán tiền mặt</li>
          <li className="font-semibold">Thanh toán online.</li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">
          a. Đối với sản phẩm có sẵn
        </span>
        <br />
        <span>Khách hàng thanh toán:</span>
        <ul className="list-disc ml-24">
          <li>100% giá trị đơn hàng trước khi giao hàng</li>
          <li>
            hoặc đặt cọc trước và thanh toán phần còn lại khi nhận hàng (tùy khu
            vực giao hàng).
          </li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">
          b. Đối với sản phẩm thiết kế riêng
        </span>
        <br />
        <span>Thanh toán theo tiến độ:</span>
        <ul className="list-disc ml-24">
          <li>50% đặt cọc khi xác nhận đơn hàng</li>
          <li>30% trước khi giao hàng hoặc trước khi lắp đặt</li>
          <li>20% còn lại sau khi bàn giao hoàn tất</li>
        </ul>
      </span>
    ),
  },
  {
    title: '5. Chính sách giao hàng',
    content: (
      <span className="text-body-medium">
        <span>
          Fitta cung cấp dịch vụ giao hàng và lắp đặt. Chi phí giao hàng phụ
          thuộc vào:
        </span>
        <ul className="list-disc ml-24">
          <li>Khoảng cách vận chuyển</li>
          <li>Khối lượng đơn hàng</li>
          <li>Điều kiện giao nhận tại công trình.</li>
        </ul>
        <span>Chi phí cụ thể sẽ được thông báo khi xác nhận đơn hàng.</span>
      </span>
    ),
  },
  {
    title: '6. Chính sách đổi trả',
    content: (
      <span className="text-body-medium">
        <span className="text-body-large font-semibold">
          a. Đối với sản phẩm có sẳn
        </span>
        <br />
        <span>Khách hàng có thể yêu cầu đổi trả trong các trường hợp sau:</span>
        <ul className="list-disc ml-24">
          <li>Sản phẩm bị lỗi kỹ thuật</li>
          <li>Sản phẩm bị hư hỏng trong quá trình vận chuyển</li>
          <li>Giao sai sản phẩm so với đơn hàng.</li>
        </ul>
        <br />
        <span>
          Thời gian thông báo:{' '}
          <strong>trong vòng 48 giờ kể từ khi nhận hàng.</strong>
        </span>
        <br />
        <br />
        <span>Điều kiện đổi trả sản phẩm phải:</span>
        <ul className="list-disc ml-24">
          <li>Còn nguyên trạng</li>
          <li>Chưa qua sử dụng</li>
          <li>Còn đầy đủ phụ kiện</li>
          <li>Còn nguyên bao bì sản phẩm</li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">
          b. Sử dụng sai cách
        </span>
        <br />
        <span>
          Do đây là sản phẩm sản xuất theo thiết kế riêng, Fitta không áp dụng
          đổi trả sau khi đơn hàng đã được xác nhận sản xuất. Các trường hợp
          ngoại lệ:
        </span>
        <ul className="list-disc ml-24">
          <li className="font-semibold">Lỗi sản phẩm</li>
          <li className="font-semibold">
            Sai khác so với thiết kế đã xác định
          </li>
        </ul>
      </span>
    ),
  },
  {
    title: '7. Chính sách đo đạc và sai số kích thước',
    content: (
      <span className="text-body-medium">
        <span>
          Đối với các sản phẩm nội thất lắp đặt theo kích thước không gian thực
          tế, việc đo đạc có thể được thực hiện theo một trong các hình thức
          sau:
        </span>
        <br />
        <br />
        <ul className="list-disc ml-24">
          <li className="font-semibold">Khách hàng tự cung cấp kích thước</li>
          <li className="font-semibold">
            Fitta thực hiện đo đạc thực tế tại công trình.
          </li>
        </ul>
        <br />
        <span>
          Trong trường hợp khách hàng tự cung cấp kích thước, khách hàng chịu
          trách nhiệm về tính chính xác của các thông số cung cấp.
        </span>
        <br />
        <br />
        <span>
          Fitta không chịu trách nhiệm đối với các sai lệch phát sinh do thông
          tin kích thước không chính xác từ phía khách hàng. Trong quá trình sản
          xuất và lắp đặt nội thất, sai số kỹ thuật nhỏ có thể phát sinh do đặc
          tính vật liệu, điều kiện thi công và dung sai sản xuất.
        </span>
        <br />
        <br />
        <span>
          Các sai số nhỏ nằm trong giới hạn dung sai kỹ thuật thông thường của
          ngành nội thất sẽ không được xem là lỗi sản xuất.
        </span>
      </span>
    ),
  },
  {
    title: '8. Xác nhận thiết kế trước khi sản xuất',
    content: (
      <span className="text-body-medium">
        <span>
          Trước khi tiến hành sản xuất, Fitta sẽ cung cấp cho khách hàng thông
          tin thiết kế bao gồm nhưng không giới hạn:
        </span>
        <br />
        <br />
        <ul className="list-decimal ml-[16px]">
          <li className="font-semibold">Kích thước sản phẩm</li>
          <li className="font-semibold">Cấu hình module</li>
          <li className="font-semibold">Vật liệu sử dụng</li>
          <li className="font-semibold">Phương án bố trí và lắp đặt.</li>
        </ul>
        <br />
        <span>
          Khách hàng có trách nhiệm kiểm tra kỹ các thông tin này trước khi xác
          nhận đơn hàng.
        </span>
        <br />
        <br />
        <span>
          Việc{' '}
          <strong>
            khách hàng thực hiện thanh toán đặt cọc hoặc thanh toán đơn hàng
            được xem là hành động xác nhận và đồng ý với toàn bộ thiết kế, kích
            thước, cấu hình và vật liệu của sản phẩm.
          </strong>
        </span>
        <br />
        <br />
        <span>
          Sau khi đơn hàng đã được xác nhận và đưa vào sản xuất, mọi thay đổi
          liên quan đến:
        </span>
        <br />
        <br />
        <ul className="list-decimal ml-[16px]">
          <li className="font-semibold">Kích thước</li>
          <li className="font-semibold">Cấu hình sản phẩm</li>
          <li className="font-semibold">Vật liệu</li>
          <li className="font-semibold">Thiết kế</li>
        </ul>
        <br />
        <span>
          có thể phát sinh chi phí điều chỉnh hoặc không thể thực hiện tùy theo
          tiến độ sản xuất.
        </span>
        <br />
        <br />
        <span>
          Fitta{' '}
          <strong>
            không chịu trách nhiệm đối với các sai sót phát sinh từ thiết kế đã
            được khách hàng xác nhận
          </strong>
          , bao gồm cả trường hợp thiết kế được thực hiện bởi khách hàng thông
          qua Web App hoặc dựa trên thông tin kích thước do khách hàng cung cấp.
        </span>
      </span>
    ),
  },
  {
    title: '9. Quy định về màu sắc và vật liệu hiển thị trên website',
    content: (
      <span className="text-body-medium">
        <span>
          Các hình ảnh, màu sắc và vật liệu hiển thị trên website hoặc Web App
          của Fitta được sử dụng nhằm mục đích minh họa và giúp khách hàng tham
          khảo lựa chọn sản phẩm.
        </span>
        <br />
        <br />
        <span>Do sự khác biệt về</span>
        <br />
        <br />
        <ul className="list-disc ml-[16px]">
          <li className="font-semibold">Màn hình hiển thị của từng thiết bị</li>
          <li className="font-semibold">Điều kiện ánh sách khi chụp ảnh</li>
          <li className="font-semibold">
            Kỹ thuật hiển thị màu trên thiết bị điện tử
          </li>
          <li className="font-semibold">Đặc tính tự nhiên của vật liệu</li>
        </ul>
        <br />
        <span>
          màu sắc và vân vật liệu hiển thị trên website có thể có sự khác biệt
          so với sản phẩm thực tế.
        </span>
        <br />
        <br />
        <span>
          Fitta không cam kết màu sắc hiển thị trên website hoặc Web App sẽ
          trùng khớp hoàn toàn 100% với sản phẩm thực tế.
        </span>
        <br />
        <br />
        <span>
          Trong trường hợp khách hàng có yêu cầu cao về độ chính xác màu sắc
          hoặc vật liệu, Fitta khuyến nghị khách hàng:
        </span>
        <br />
        <br />
        <ul className="list-disc ml-[16px]">
          <li className="font-semibold">
            Xem mẫu vật liệu thực tế tại showroom
          </li>
          <li className="font-semibold">
            Yêu cầu mẫu vật liệu trước khi xác nhận đơn hàng.
          </li>
        </ul>
        <br />
        <span>
          Sự khác biệt nhỏ về màu sắc, vân vật liệu hoặc sắc độ trong giới hạn
          đặc tính tự nhiên của vật liệu sẽ không được xem là lỗi sản xuất hoặc
          căn cứ để đổi trả sản phẩm.
        </span>
      </span>
    ),
  },
  {
    title: '10. Chính sách bảo hành',
    content: (
      <span className="text-body-medium">
        <span>
          Tất cả sản phẩm của Fitta được áp dụng chính sách bảo hành riêng.
        </span>
        <br />
        <br />
        <span>
          Chi tiết về phạm vi và điều kiện bảo hành được quy định tại Trang
          Chính Sách Bảo Hành trên website Fitta.
        </span>
      </span>
    ),
  },
];

const englishSalesPolicySections = [
  {
    title: '1. Scope of Application',
    content: (
      <span className="text-body-medium">
        <span>
          This policy applies to all customers purchasing products through the
          following channels:
        </span>
        <br />
        <br />
        <ul className="list-disc ml-24">
          <li className="font-semibold">Fitta official website</li>
          <li className="font-semibold">Fitta showroom</li>
          <li className="font-semibold">
            Fitta online sales channels (Facebook, Zalo or other platforms)
          </li>
        </ul>
      </span>
    ),
  },
  {
    title: '2. Product Classification',
    content: (
      <span className="text-body-medium">
        <span>Fitta products are divided into 3 main groups</span>
        <br />
        <br />
        <span className="text-body-large font-semibold">
          a. Pre-made wooden furniture
        </span>
        <br />
        <span>
          These are products designed and manufactured according to standard
          modules. Examples:
        </span>
        <ul className="list-disc ml-24">
          <li>Cabinets</li>
          <li>Tables</li>
          <li>Shelves</li>
          <li>Beds</li>
          <li>Modular kitchen cabinets</li>
        </ul>
        <span>Characteristics</span>
        <ul className="list-disc ml-24">
          <li>Products are ready-made or manufactured quickly</li>
          <li>Sizes and configurations follow Fitta standards</li>
          <li>No custom size changes available.</li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">b. Pre-made sofas</span>
        <br />
        <span>Sofa models are pre-designed with options for:</span>
        <ul className="list-disc ml-24">
          <li>Color</li>
          <li>Material</li>
          <li>Standard sizes</li>
        </ul>
        <span>
          In some cases, customers may change fabric or leather colors according
          to Fitta&apos;s material options.
        </span>
        <br />
        <br />
        <span className="text-body-large font-semibold">
          c. Furniture designed via Web-App
        </span>
        <br />
        <span>Customers can:</span>
        <ul className="list-disc ml-24">
          <li>Design furniture directly on the Web App</li>
          <li>Customize sizes</li>
          <li>Customize modules</li>
          <li>Customize materials.</li>
        </ul>
        <span>
          After customers confirm the design and order, Fitta will proceed with
          manufacturing according to the finalized design. This is a custom-made
          product.
        </span>
      </span>
    ),
  },
  {
    title: '3. Ordering Process',
    content: (
      <span className="text-body-medium">
        <span className="text-body-large font-semibold">
          a. For pre-made wooden furniture and sofas
        </span>
        <br />
        <span>Ordering process:</span>
        <ul className="list-disc ml-24">
          <li>Customer selects products on website or at showroom</li>
          <li>Fitta confirms the order</li>
          <li>Customer makes payment</li>
          <li>Beds</li>
          <li>Fitta proceeds with delivery.</li>
        </ul>
        <br />
        <span>Delivery time</span>
        <br />
        <ul className="list-disc ml-24">
          <li>
            Ho Chi Minh City inner districts (pre-merger boundaries): 1 – 3
            business days.
          </li>
          <li>
            Outer provinces (outside old Ho Chi Minh City boundaries): 3 – 7
            business days depending on delivery area.
          </li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">
          b. For products designed via Web App
        </span>
        <span>Ordering process:</span>
        <ul className="list-disc ml-24">
          <li>Customer designs product on Web App</li>
          <li>Fitta confirms design and provides quote</li>
          <li>Customer makes deposit on order</li>
          <li>Fitta proceeds with manufacturing</li>
          <li>Delivery and installation.</li>
        </ul>
        <br />
        <br />
        <span>
          Manufacturing time depends on the materials customer chooses:
        </span>
        <ul className="list-disc ml-24">
          <li>
            <strong>5 – 7 business days:</strong> applied when customer selects
            panels already available in Fitta&apos;s standard material catalog.
          </li>
          <li>
            <strong>14 – 24 business days:</strong> applied when customer
            selects panels outside the standard catalog or requires custom
            materials.
          </li>
        </ul>
        <span>
          Time may vary depending on order size and manufacturing conditions.
        </span>
      </span>
    ),
  },
  {
    title: '4. Payment Policy',
    content: (
      <span className="text-body-medium">
        <span>Fitta accepts the following payment methods:</span>
        <br />
        <br />
        <ul className="list-disc ml-24">
          <li className="font-semibold">Bank transfer</li>
          <li className="font-semibold">Cash payment</li>
          <li className="font-semibold">Online payment.</li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">
          a. For pre-made products
        </span>
        <br />
        <span>Customer payment:</span>
        <ul className="list-disc ml-24">
          <li>100% of order value before delivery</li>
          <li>
            or deposit first and pay the remainder upon receiving (varies by
            delivery area).
          </li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">
          b. For custom designed products
        </span>
        <br />
        <span>Payment schedule:</span>
        <ul className="list-disc ml-24">
          <li>50% deposit upon order confirmation</li>
          <li>30% before delivery or before installation</li>
          <li>20% remaining after complete handover</li>
        </ul>
      </span>
    ),
  },
  {
    title: '5. Delivery Policy',
    content: (
      <span className="text-body-medium">
        <span>
          Fitta provides delivery and installation services. Delivery costs
          depend on:
        </span>
        <ul className="list-disc ml-24">
          <li>Shipping distance</li>
          <li>Order weight</li>
          <li>Delivery conditions at the project site.</li>
        </ul>
        <span>Specific costs will be provided upon order confirmation.</span>
      </span>
    ),
  },
  {
    title: '6. Exchange and Return Policy',
    content: (
      <span className="text-body-medium">
        <span className="text-body-large font-semibold">
          a. For pre-made products
        </span>
        <br />
        <span>
          Customers may request exchange or return in the following cases:
        </span>
        <ul className="list-disc ml-24">
          <li>Product has technical defects</li>
          <li>Product is damaged during shipping</li>
          <li>Wrong product delivered.</li>
        </ul>
        <br />
        <span>
          Notification time:{' '}
          <strong>within 48 hours of receiving the product.</strong>
        </span>
        <br />
        <br />
        <span>Exchange/return conditions require the product to:</span>
        <ul className="list-disc ml-24">
          <li>Remain in original condition</li>
          <li>Be unused</li>
          <li>Have all accessories</li>
          <li>Have original packaging intact</li>
        </ul>
        <br />
        <span className="text-body-large font-semibold">b. Misuse</span>
        <br />
        <span>
          As this is a product manufactured according to custom design, Fitta
          does not accept exchanges or returns after the order has been
          confirmed for manufacturing. Exceptions are:
        </span>
        <ul className="list-disc ml-24">
          <li className="font-semibold">Product defects</li>
          <li className="font-semibold">
            Differences from the confirmed design
          </li>
        </ul>
      </span>
    ),
  },
  {
    title: '7. Measurement and Size Tolerance Policy',
    content: (
      <span className="text-body-medium">
        <span>
          For furniture installed according to actual space dimensions,
          measurements may be taken in one of the following ways:
        </span>
        <br />
        <br />
        <ul className="list-disc ml-24">
          <li className="font-semibold">Customer provides dimensions</li>
          <li className="font-semibold">
            Fitta performs on-site measurement at the project.
          </li>
        </ul>
        <br />
        <span>
          If the customer provides dimensions, the customer is responsible for
          the accuracy of the provided specifications.
        </span>
        <br />
        <br />
        <span>
          Fitta is not responsible for discrepancies resulting from inaccurate
          dimensional information provided by the customer. During the
          manufacturing and installation of furniture, minor technical
          tolerances may occur due to material properties, construction
          conditions, and manufacturing tolerances.
        </span>
        <br />
        <br />
        <span>
          Small discrepancies within normal industry tolerances will not be
          considered manufacturing defects.
        </span>
      </span>
    ),
  },
  {
    title: '8. Design Confirmation Before Manufacturing',
    content: (
      <span className="text-body-medium">
        <span>
          Before proceeding with manufacturing, Fitta will provide customers
          with design information including but not limited to:
        </span>
        <br />
        <br />
        <ul className="list-decimal ml-[16px]">
          <li className="font-semibold">Product dimensions</li>
          <li className="font-semibold">Module configuration</li>
          <li className="font-semibold">Materials to be used</li>
          <li className="font-semibold">Layout and installation plan.</li>
        </ul>
        <br />
        <span>
          Customers are responsible for carefully reviewing this information
          before confirming the order.
        </span>
        <br />
        <br />
        <span>
          When{' '}
          <strong>
            a customer makes payment (deposit or full payment), this constitutes
            confirmation and agreement with the complete design, dimensions,
            configuration, and materials of the product.
          </strong>
        </span>
        <br />
        <br />
        <span>
          Once an order has been confirmed and entered into production, any
          changes to:
        </span>
        <br />
        <br />
        <ul className="list-decimal ml-[16px]">
          <li className="font-semibold">Size</li>
          <li className="font-semibold">Product configuration</li>
          <li className="font-semibold">Materials</li>
          <li className="font-semibold">Design</li>
        </ul>
        <br />
        <span>
          may result in adjustment costs or may not be possible depending on the
          manufacturing stage.
        </span>
        <br />
        <br />
        <span>
          Fitta{' '}
          <strong>
            is not responsible for any errors resulting from the design already
            confirmed by the customer
          </strong>
          , including cases where the design was created by the customer through
          the Web App or based on dimensional information provided by the
          customer.
        </span>
      </span>
    ),
  },
  {
    title: '9. Website Color and Material Display Policy',
    content: (
      <span className="text-body-medium">
        <span>
          Images, colors, and materials displayed on Fitta&apos;s website or Web
          App are used for illustration purposes to help customers make informed
          product choices.
        </span>
        <br />
        <br />
        <span>Due to differences in</span>
        <br />
        <br />
        <ul className="list-disc ml-[16px]">
          <li className="font-semibold">
            Display screens of different devices
          </li>
          <li className="font-semibold">
            Lighting conditions during photography
          </li>
          <li className="font-semibold">
            Color display technology on electronic devices
          </li>
          <li className="font-semibold">Natural properties of materials</li>
        </ul>
        <br />
        <span>
          colors and material patterns displayed on the website may differ from
          the actual product.
        </span>
        <br />
        <br />
        <span>
          Fitta does not guarantee that colors displayed on the website or Web
          App will match the actual product 100% exactly.
        </span>
        <br />
        <br />
        <span>
          If customers have high requirements for color or material accuracy,
          Fitta recommends:
        </span>
        <br />
        <br />
        <ul className="list-disc ml-[16px]">
          <li className="font-semibold">
            View actual material samples at the showroom
          </li>
          <li className="font-semibold">
            Request material samples before confirming the order.
          </li>
        </ul>
        <br />
        <span>
          Minor differences in color, material patterns, or tone within the
          limits of natural material properties will not be considered
          manufacturing defects or grounds for product exchange or return.
        </span>
      </span>
    ),
  },
  {
    title: '10. Warranty Policy',
    content: (
      <span className="text-body-medium">
        <span>
          All Fitta products are covered by a separate warranty policy.
        </span>
        <br />
        <br />
        <span>
          Details on warranty scope and conditions are provided on Fitta&apos;s
          Warranty Policy page on the website.
        </span>
      </span>
    ),
  },
];

const SalesPolicy = () => {
  const { t } = useTranslation();
  const salesPolicySections =
    i18n.language === 'vi'
      ? vietnameseSalesPolicySections
      : englishSalesPolicySections;

  return (
    <div className="warrenty-policy flex lg:p-40 py-32 md:px-20 px-16 flex-col lg:items-center items-start gap-24 self-stretch rounded-[8px] bg-fills-white">
      <span className="text-headline-small">{t('Sales policy')}</span>
      <span className="text-body-medium self-stretch">
        {i18n.language === 'vi' ? (
          <>
            Fitta cung cấp các giải pháp nội thất hiện đại, bao gồm:
            <strong>
              Nội thất gỗ có sẵn, Sofa có sẵn, Nội thất thiết kế theo yêu cầu
              thông qua Web App
            </strong>
            . Chính sách bán hàng này quy định các điều khoản liên quan đến việc
            đặt hàng, thanh toán, giao nhận và đổi trả sản phẩm tại Fitta.
          </>
        ) : (
          <>
            Fitta provides modern interior solutions, including:
            <strong>
              Pre-made wooden furniture, Pre-made sofas, Furniture designed on
              demand via Web App
            </strong>
            . This sales policy sets out the terms and conditions related to
            ordering, payment, delivery, and product exchange or return at
            Fitta.
          </>
        )}
      </span>
      <Divider className="m-0 !p-0" type="horizontal" />
      {salesPolicySections.flatMap((item, index) => [
        <div
          key={`section-${index}`}
          className="flex flex-col items-start gap-[16px] self-stretch"
        >
          <span className="text-title-large">{item.title}</span>
          {item.content}
        </div>,
        index < salesPolicySections.length - 1 && (
          <Divider
            key={`divider-${index}`}
            className="m-0 !p-0"
            type="horizontal"
          />
        ),
      ])}
    </div>
  );
};

const TermsOfUse = () => {
  const language = i18n.language === 'vi' ? 'vi' : 'en';
  const policy = POLICIES_TEXT.termsOfUse[language];

  return (
    <div className="warrenty-policy flex lg:p-40 py-32 md:px-20 px-16 flex-col lg:items-center items-start gap-24 self-stretch rounded-[8px] bg-fills-white">
      <span className="text-headline-small">{policy.title}</span>
      <span className="text-body-medium self-stretch">{policy.description}</span>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section1.title}</span>
        <span className="text-body-medium">
          <span>{policy.section1.content}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section1.items.map((item, idx) => (
              <li key={idx} className="font-semibold">
                {item}
              </li>
            ))}
          </ul>
          <br />
          <span>{policy.section1.footer}</span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section2.title}</span>
        <span className="text-body-medium">
          <span>{policy.section2.permitted}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section2.permittedItems.map((item, idx) => (
              <li key={idx} className="font-semibold">
                {item}
              </li>
            ))}
          </ul>
          <br />
          <span>{policy.section2.notPermitted}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section2.notPermittedItems.map((item, idx) => (
              <li key={idx} className="font-semibold">
                {item}
              </li>
            ))}
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section3.title}</span>
        <span className="text-body-medium">
          <span>{policy.section3.content}</span>
          <br />
          <span>{policy.section3.responsible}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section3.responsibleItems.map((item, idx) => (
              <li key={idx} className="font-semibold">
                {item}
              </li>
            ))}
          </ul>
          <br />
          <span>{policy.section3.footer}</span>
        </span>
      </div>
    </div>
  );
};

const PrivacyPolicy = () => {
  const language = i18n.language === 'vi' ? 'vi' : 'en';
  const policy = POLICIES_TEXT.privacyPolicy[language];

  const renderItem = (item, idx) => (
    <li key={idx} className="font-semibold">
      {item.includes('{{phone}}')
        ? item.replace('{{phone}}', CONST.laNhaPhone)
        : item}
    </li>
  );

  return (
    <div className="warrenty-policy flex lg:p-40 py-32 md:px-20 px-16 flex-col lg:items-center items-start gap-24 self-stretch rounded-[8px] bg-fills-white">
      <span className="text-headline-small">{policy.title}</span>
      <span className="text-body-medium self-stretch">
        {policy.description}
      </span>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section1.title}</span>
        <span className="text-body-medium">
          <span>{policy.section1.content}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section1.items.map(renderItem)}
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section2.title}</span>
        <span className="text-body-medium">
          <span>{policy.section2.content}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section2.items.map(renderItem)}
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section3.title}</span>
        <span className="text-body-medium">
          <span>{policy.section3.content}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section3.items.map(renderItem)}
          </ul>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section4.title}</span>
        <span className="text-body-medium">
          <span>{policy.section4.content}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section4.items.map(renderItem)}
          </ul>
          <br />
          <span>{policy.section4.footer}</span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section5.title}</span>
        <span className="text-body-medium">
          <span>{policy.section5.content}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section5.items.map(renderItem)}
          </ul>
          <br />
          <span>{policy.section5.footer}</span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section6.title}</span>
        <span className="text-body-medium">
          <span>{policy.section6.content}</span>
        </span>
      </div>
      <Divider className="m-0 !p-0" type="horizontal" />
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <span className="text-title-large">{policy.section7.title}</span>
        <span className="text-body-medium">
          <span>{policy.section7.content}</span>
          <br />
          <br />
          <ul className="list-disc ml-24">
            {policy.section7.items.map(renderItem)}
          </ul>
        </span>
      </div>
    </div>
  );
};
